export const ResultData = [
  { val: 111, credit: 3000000 },
  { val: 112, credit: 4000000 },
  { val: 113, credit: 4000000 },
  { val: 114, credit: 4000000 },
  { val: 115, credit: 5000000 },
  { val: 116, credit: 4000000 },

  { val: 121, credit: 3000000 },
  { val: 122, credit: 4000000 },
  { val: 123, credit: 4000000 },
  { val: 124, credit: 4000000 },
  { val: 125, credit: 5000000 },
  { val: 126, credit: 4000000 },

  { val: 131, credit: 0 },
  { val: 1321, credit: 3000000 },
  { val: 1322, credit: 4000000 },
  { val: 1323, credit: 4000000 },
  { val: 1324, credit: 4000000 },
  { val: 1325, credit: 5000000 },
  { val: 1326, credit: 4000000 },

  { val: 141, credit: 0 },
  { val: 1421, credit: 3000000 },
  { val: 1422, credit: 4000000 },
  { val: 1423, credit: 4000000 },
  { val: 1424, credit: 4000000 },
  { val: 1425, credit: 5000000 },
  { val: 1426, credit: 4000000 },

  { val: 211, credit: 3000000 },
  { val: 212, credit: 4000000 },
  { val: 213, credit: 4000000 },
  { val: 214, credit: 4000000 },
  { val: 215, credit: 5000000 },
  { val: 216, credit: 4000000 },

  { val: 22, credit: 0 },

  { val: 3111, credit: 3000000 },
  { val: 3112, credit: 4000000 },
  { val: 3113, credit: 4000000 },
  { val: 3114, credit: 4000000 },
  { val: 3115, credit: 5000000 },
  { val: 3116, credit: 4000000 },

  { val: 3211, credit: 3000000 },
  { val: 3212, credit: 4000000 },
  { val: 3213, credit: 4000000 },
  { val: 3214, credit: 4000000 },
  { val: 3215, credit: 5000000 },
  { val: 3216, credit: 4000000 },

  { val: 322, credit: 0 },

  { val: 411, credit: 3000000 },
  { val: 412, credit: 4000000 },
  { val: 413, credit: 4000000 },
  { val: 414, credit: 4000000 },
  { val: 415, credit: 5000000 },
  { val: 416, credit: 4000000 },

  { val: 42, credit: 0 },

  { val: 431, credit: 0 },
  { val: 4321, credit: 3000000 },
  { val: 4322, credit: 4000000 },
  { val: 4323, credit: 4000000 },
  { val: 4324, credit: 4000000 },
  { val: 4325, credit: 5000000 },
  { val: 4326, credit: 4000000 },

  { val: 5, credit: 0 },

  { val: 611, credit: 3000000 },
  { val: 612, credit: 4000000 },
  { val: 613, credit: 4000000 },
  { val: 614, credit: 4000000 },
  { val: 615, credit: 5000000 },
  { val: 616, credit: 4000000 },

  { val: 62, credit: 0 },
  
  { val: 71, credit: 0 },

  { val: 721, credit: 3000000 },
  { val: 722, credit: 4000000 },
  { val: 723, credit: 4000000 },
  { val: 724, credit: 4000000 },
  { val: 725, credit: 5000000 },
  { val: 726, credit: 4000000 },
];
